var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4305 8.09655C18.1139 7.41313 19.222 7.41313 19.9054 8.09655L38.5721 26.7632C39.2555 27.4466 39.2555 28.5547 38.5721 29.2381L19.9054 47.9048C19.222 48.5882 18.1139 48.5882 17.4305 47.9048C16.7471 47.2213 16.7471 46.1133 17.4305 45.4299L34.8598 28.0007L17.4305 10.5714C16.7471 9.888 16.7471 8.77997 17.4305 8.09655Z",
    fill: "#000928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.f38102c4fd6e275c2d995c834ab6a958.svg";
export { ForwardRef as ReactComponent };